import { Http } from "@/util";

export function getActiveRoute(driverId) {
  return Http.get("/admin/route/active/list", { driverId });
}

export function getActiveRouteList(param) {
  return Http.post("/admin/route/active/list/with/orders", param);
}

export function getRouteListWithOrders(param) {
  return Http.post("/admin/route/list/with/orders", param);
}

export function getRouteList(param) {
  return Http.post("/admin/route/list", param);
}

export function getRouteReplay(routeId) {
  return Http.get("/admin/route/route_detail", { routeId });
}

export function getRouteById(routeId) {
  return Http.get("/admin/route/get", { routeId });
}

export function getRouteShunt(routeId, testId) {
  const param = { routeId, _hideLoading: true };
  if (testId) {
    param.testId = testId;
  }
  return Http.get("/admin/route/shunt/list", param);
}

// 保存分流信息
export function saveRouteShunt(param) {
  // 过滤掉空id
  if (param.orderIds) {
    param.orderIds = param.orderIds.filter((item) => item);
  }
  return Http.post("/admin/route/save/shunt_plan", param);
}

// 分流订单排序
export function sortShuntOrder(param) {
  param._hideLoading = true;
  // 过滤掉空id
  if (param.orderIds) {
    param.orderIds = param.orderIds.filter((item) => item);
  }
  return Http.post("/admin/route/shunt/sort_order", param);
}

// 分流订单排序
export function delShuntOrder(param) {
  param._hideLoading = true;
  return Http.post("/admin/route/del/shunt", param);
}

// 发送流信息给乘客
export function sendShuntMsg(param) {
  return Http.get("/admin/route/send/shunt_msg", param);
}

// 查询接送排序详情
export function getRoutePlan(routeId) {
  return Http.get("/admin/route/query/route_plan", { routeId });
}

// 为模拟派单做准备
export function prepareForTestRoutePlan(routeId, testOrderIds, testId) {
  return Http.get("/admin/route/prepare/test_route_plan", { routeId, testOrderIds, testId });
}

// 创建系统排序
export function createSysRoutePlan(param) {
  return Http.post("/admin/route/system/route_plan", param);
}

// 模拟规划
export function getTestRoutePlan(param) {
  return Http.post("/admin/route/get/test_route_plan", param);
}

/**
 * 系统自动分流；specShuntOrderIds 非空时仅对这些订单做分流（与后台 chooseShuntOrder 一致）
 * payload 须含：routeId, isPick, testId；可选 orderIds、specShuntOrderIds、startTime、高速出入口字段（与 RoutePlan 一致）
 */
export function autoShuntOrder(payload) {
  return Http.post("/admin/route/create/test_shunt_order", payload);
}

/** 关闭规划弹窗时删除本会话的测试分流 */
export function deleteTestRouteShunt(routeId, testId) {
  return Http.get("/admin/route/delete/test_shunt", {
    routeId,
    testId,
    _hideLoading: true
  });
}

// 手动指定接送顺序
export function applyTestRoutePlan(param) {
  return Http.post("/admin/route/apply/test_route_plan", param);
}

// 模拟指定接送顺序
export function simulateRoutePlan(param) {
  return Http.post("/admin/route/simulate/route_plan", param);
}

// 确认规划
export function confirmRoutePlan(routeId, changeDesc, tipDriver) {
  return Http.get("/admin/route/confirm/route_plan", { routeId, changeDesc, tipDriver });
}

export function getRoutePlanChangeLog(routeId) {
  return Http.get("/admin/route/route_plan/change_log", { routeId });
}

export function getRouteLogs(routeId) {
  return Http.get("/admin/route/operate/log", { routeId, _hideLoading: true });
}

export function changeRouteAreaControl(param) {
  return Http.post("/admin/route/change/area_control", param);
}

export function saveOrUpdateRouteProblem(param) {
  return Http.post("/admin/route/save_update/route_problem", param);
}

export function getRouteProblemList(routeId) {
  return Http.get("/admin/route/list/route_problem", { routeId });
}
